export enum DimensionType {
  VH = 'vh',
  VW = 'vw',
  PX = 'px',
  PERCENT = '%',
  EM = 'em',
  CH = 'ch',
  REM = 'rem',
  EX = 'ex',
  CM = 'cm',
  MM = 'mm',
  IN = 'in',
  PT = 'pt',
  PC = 'pc',
  Vmin = 'vmin',
  Vmax = 'vmax',
  FR = 'fr',
  AUTO = 'auto'
}
